import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import {
  apiGetOpenedGames,
  apiGetProductOverview,
  apiGetProductReport,
  apiGetProductReportDetail,
} from "../service";

export const useGetProductReport = ({ options, params, categoryId, gameId }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.PRODUCT_REPORT, categoryId, gameId, ..._arrParams],
    ({ pageParam = 1 }) =>
      apiGetProductReport({ ...params, page: pageParam }, categoryId, gameId).then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
      cacheTime: 0,
    },
  );
};

export const useGetProductReportDetail = ({ options, params, categoryId, gameId }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.PRODUCT_REPORT_DETAIL, categoryId, gameId, ..._arrParams],
    ({ pageParam = 1 }) =>
      apiGetProductReportDetail({ ...params, page: pageParam }, categoryId, gameId).then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
      cacheTime: 0,
    },
  );
};

export const useGetOpenedGames = ({ options }) => {
  return useQuery([queryKey.OPENED_GAME], () => apiGetOpenedGames().then((res) => res.data.data), {
    ...options,
  });
};

export const useGetProductOverview = ({ options }) => {
  return useQuery(
    [queryKey.PRODUCT_OVERVIEW],
    () => apiGetProductOverview().then((res) => res.data.data),
    { ...options },
  );
};
